import React from 'react';
import { Skeleton, SkeletonAvatar } from '../ui';

const ProfileSkeleton: React.FC = () => (
  <div className="py-6 animate-fade-in">
    {/* Page Header Skeleton */}
    <div className="mb-8">
      <Skeleton variant="text" width={180} height={36} className="mb-2" />
      <Skeleton variant="text" width={300} height={16} />
    </div>

    {/* Profile Card Skeleton */}
    <div className="au-card p-6">
      <div className="flex flex-col md:flex-row gap-6">
        {/* Avatar */}
        <div className="flex-shrink-0">
          <SkeletonAvatar size="lg" />
        </div>

        {/* Profile Info */}
        <div className="flex-1 space-y-4">
          <div>
            <Skeleton variant="text" width="30%" height={14} className="mb-2" />
            <Skeleton variant="text" width="50%" height={24} />
          </div>
          <div>
            <Skeleton variant="text" width="25%" height={14} className="mb-2" />
            <Skeleton variant="text" width="60%" height={20} />
          </div>
          <div>
            <Skeleton variant="text" width="20%" height={14} className="mb-2" />
            <Skeleton variant="text" width="40%" height={20} />
          </div>
        </div>
      </div>

      {/* Additional Details */}
      <div className="mt-6 pt-6 border-t border-au-divider">
        <Skeleton variant="text" width="25%" height={18} className="mb-4" />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <Skeleton variant="text" width="40%" height={14} className="mb-2" />
            <Skeleton variant="text" width="70%" height={16} />
          </div>
          <div>
            <Skeleton variant="text" width="40%" height={14} className="mb-2" />
            <Skeleton variant="text" width="60%" height={16} />
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default ProfileSkeleton;
